import React, {Component} from "react";
import ContingencyTrust from "./ContingencyTrustView";
import {CatalogContingencyService} from "../../../service/catalog/CatalogContingencyService";
import {ContingencyTrustService} from "../../../service/operation/contingencyTrust/ContingencyTrustService";
import {Button} from "primereact/button";
import {Growl} from "primereact/growl";

export default class ContingencyTrustContainer extends Component {
    constructor(props) {
        super(props);

        this.catalogService = new CatalogContingencyService();
        this.contingencyTrustService = new ContingencyTrustService();

        this.loading = this.loading.bind(this);

        this.getCatStatusContingencyTrust = this.getCatStatusContingencyTrust.bind(this);
        this.getCatLoanFlow = this.getCatLoanFlow.bind(this);
        this.getCatInstitution = this.getCatInstitution.bind(this);

        this.state = {
            isLoading: true,
            catStatusContingencyTrust: this.getCatStatusContingencyTrust(),
            catLoanFlow: this.getCatLoanFlow(),
            catInstitution: this.getCatInstitution(),
            contingencyTrust: [],
            folioFilter: '',
            statusContingencyFilter: [],
            catInstitutionFilter: [],
            catLoanFlowFilter: [],
            selectedInstruction: []
        };


        this.searchContingency = this.searchContingency.bind(this);
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.clearFilters = this.clearFilters.bind(this);
        this.selectRowInstruction = this.selectRowInstruction.bind(this);
        this.exportSelection = this.exportSelection.bind(this);
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    getCatStatusContingencyTrust() {
        this.loading();
        this.catalogService.getCatStatusContingencyTrust().then(
            catStatusContingencyTrust =>
                this.setState({
                    catStatusContingencyTrust: catStatusContingencyTrust,
                    isLoading: false
                }))
    }

    getCatLoanFlow() {
        this.loading();
        this.catalogService.getCatLoanFlow().then(
            catLoanFlow =>
                this.setState({
                    catLoanFlow: catLoanFlow,
                    isLoading: false
                }))
    }

    getCatInstitution() {
        this.loading();
        this.catalogService.getCatInstitution().then(
            catInstitution =>
                this.setState({
                    catInstitution: catInstitution,
                    isLoading: false
                }))
    }

    searchContingency() {
        this.loading();
        this.contingencyTrustService.getInstructions(
            this.state.folioFilter,
            this.state.statusContingencyFilter.id,
            this.state.catInstitutionFilter.id,
            this.state.catLoanFlowFilter.id,
        ).then(
            contingencyTrust =>
                this.setState({
                    contingencyTrust: contingencyTrust,
                    isLoading: false
                })
        )
    }

    onChangeFilter(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }

    selectRowInstruction(event) {
        this.setState({
            selectedInstruction: event.value
        })
    }

    clearFilters() {
        this.setState({
            folioFilter: '',
            statusContingencyFilter: [],
            catInstitutionFilter: [],
            catLoanFlowFilter: []
        })
    }

    exportSelection() {
        this.loading();
        let keys = [];
        let ban = false;


        this.state.selectedInstruction.forEach(instruction => {
            keys.push(
                instruction.loanId + "_" +
                instruction.consecutiveFlow + "_" +
                instruction.idFlow + "_" +
                instruction.idInstrument + "_" +
                instruction.statusLoan
            );
            if (instruction.idStatusContingencyTrust === 3) {
                ban = true;
            }
        });

        if (keys.length === 0){
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Favor de seleccionar al menos una garantía a exportar'
            });
        }
        else {
            if (ban) {
                alert('Existen instrucciones que ya fueron exportadas');
            }

            this.contingencyTrustService.getFileContingency(keys).then(response => {
                this.setState({
                    selectedInstruction: []
                });
                this.searchContingency();
            });
        }
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        const {
            catStatusContingencyTrust,
            catLoanFlow,
            catInstitution,
            contingencyTrust,
            statusContingencyFilter,
            catInstitutionFilter,
            catLoanFlowFilter,
            folioFilter,
            selectedInstruction
        } = this.state;

        let headerContingencyTrust =
            <div style={{textAlign: 'right'}}>
                <Button type="button"
                        iconPos="left"
                        label="Exportar"
                        style={{marginRight: '.5em'}}
                        onClick={this.exportSelection}
                        className="p-button-secondary"/>
            </div>;

        return (
            <ContingencyTrust
                messagesGrowl={messagesGrowl}
                headerContingencyTrust={headerContingencyTrust}
                isLoading={this.state.isLoading}
                catStatusContingencyTrust={catStatusContingencyTrust}
                catLoanFlow={catLoanFlow}
                catInstitution={catInstitution}
                searchContingency={this.searchContingency}
                contingencyTrust={contingencyTrust}
                folioFilter={folioFilter}
                onChangeFilter={this.onChangeFilter}
                statusContingencyFilter={statusContingencyFilter}
                catInstitutionFilter={catInstitutionFilter}
                catLoanFlowFilter={catLoanFlowFilter}
                clearFilters={this.clearFilters}
                selectedInstruction={selectedInstruction}
                selectRowInstruction={this.selectRowInstruction}
            />)
    }
};